export class TipoDireccion {
  public static instancia: TipoDireccion;

  public static readonly TIPO_DIRECCION_TRABAJO = new TipoDireccion(
    'TR',
    'Trabajo'
  );
  public static readonly TIPO_DIRECCION_RESIDENCIA = new TipoDireccion(
    'RS',
    'Residencia'
  );
  public static readonly TIPO_DIRECCION_OTRO = new TipoDireccion('OT', 'Otro');

  public static readonly TIPO_DIRECCION_OFICINA_PRINCIPAL = new TipoDireccion(
    'OP',
    'Oficina principal'
  );
  public static readonly TIPO_DIRECCION_REP_LEGAL = new TipoDireccion(
    'RL',
    'Rep. legal'
  );
  public static readonly TIPO_DIRECCION_SURCURSAL = new TipoDireccion(
    'CO',
    'Sucursal'
  );

  public static readonly TIPOS_DIRECCIONES = [
    TipoDireccion.TIPO_DIRECCION_TRABAJO,
    TipoDireccion.TIPO_DIRECCION_RESIDENCIA,
    TipoDireccion.TIPO_DIRECCION_OTRO,
    TipoDireccion.TIPO_DIRECCION_OFICINA_PRINCIPAL,
    TipoDireccion.TIPO_DIRECCION_REP_LEGAL,
    TipoDireccion.TIPO_DIRECCION_SURCURSAL,
  ];

  id: String;
  descripcion: String;

  public static getLista() {
    if (!this.instancia) {
      this.instancia = new TipoDireccion('NOP', 'NOP');
    }
    return this.TIPOS_DIRECCIONES;
  }

  public static get() {
    if (!this.instancia) {
      this.instancia = new TipoDireccion('NOP', 'NOP');
    }
    return this.instancia;
  }

  constructor(id: String, descripcion: String) {
    this.id = id;
    this.descripcion = descripcion;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/tipo/tipo-direccion.class.ts